import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { DeferRenderingModule } from 'app/shared/directives/defer-rendering/defer-rendering.module';
import { TabsModule } from '../../../tabs/tabs.module';
import { OccurrenceRegisterModule } from './components/occurrence-register/occurrence-register.module';
import { SearchOccurrenceModule } from './components/search-occurrence/search-occurrence.module';
import { OccurrencesManagementComponent } from './occurrences-management.component';

@NgModule({
  imports: [
    CommonModule,
    OccurrenceRegisterModule,
    SearchOccurrenceModule,
    TabsModule,
    DeferRenderingModule,
    BlockModalDragModule,
  ],
  declarations: [OccurrencesManagementComponent],
  exports: [OccurrencesManagementComponent],
})
export class OccurrencesManagementModule {}
